import request from '@/utils/request'

const root = '/seller/combo-import'

// import_id 为后端幂等契约参数（POST /seller/combo-import/batches?import_id=）：
// 同键同内容服务端回放首次结果；同键异体返回409；不传则每次视为新导入。
// message:false 关闭全局错误提示，由 Wizard 按 409/非409 分别给出明确文案
export function createComboBatch (data, importId) {
  const params = importId ? { import_id: importId } : {}
  return request({ url: `${root}/batches`, method: 'post', headers: { 'Content-Type': 'application/json' }, params, data, loading: false, message: false })
}

export function getComboBatches (params, options) {
  return request(Object.assign({ url: `${root}/batches`, method: 'get', params }, options))
}

// 统一导入批次列表（2026-11-02 用户裁定：普通+套餐/混合批同一页同一表，不分页签）：
// 服务端 UNION 筛选/排序/分页/总数，禁止前端拼接两接口或内存分页；
// 行 batch_kind=NORMAL/COMBO/MIXED 供详情/支付/取消分路到各自既有链路
export function getUnifiedBatches (params, options) {
  return request(Object.assign({ url: `${root}/unified-batches`, method: 'get', params }, options))
}

export function getComboBatch (batchSn, options) {
  return request(Object.assign({ url: `${root}/batches/${encodeURIComponent(batchSn)}`, method: 'get' }, options))
}

export function payComboBatch (batchSn, requestId) {
  return request({ url: `${root}/batches/${encodeURIComponent(batchSn)}/pay`, method: 'post', headers: { 'Content-Type': 'application/json' }, data: { request_id: requestId }, loading: false })
}

export function cancelComboBatch (batchSn) {
  return request({ url: `${root}/batches/${encodeURIComponent(batchSn)}/cancel`, method: 'post', headers: { 'Content-Type': 'application/json' }, data: {} })
}

export function getComboBalance () {
  return request({ url: `${root}/account/balance`, method: 'get' })
}

export function getComboFulfillments (params) {
  return request({ url: `${root}/fulfillment/orders`, method: 'get', params })
}

export function shipComboFulfillment (fulfillmentSn, data) {
  return request({ url: `${root}/fulfillment/orders/${encodeURIComponent(fulfillmentSn)}/ship`, method: 'post', headers: { 'Content-Type': 'application/json' }, data })
}

export function receiveComboFulfillment (fulfillmentSn) {
  return request({ url: `${root}/fulfillment/orders/${encodeURIComponent(fulfillmentSn)}/receive`, method: 'post', headers: { 'Content-Type': 'application/json' }, data: {} })
}

export function getComboSettlement (params) {
  return request({ url: `${root}/settlements/items`, method: 'get', params })
}

export function getComboBillSettlement (caId) {
  return request({ url: `${root}/settlements/items-caid`, method: 'get', params: { ca_id: caId } })
}

// 导入校验结果「商品/套餐名称」列的只读预解析（r6：校验表展示名称）。
// 复用现有商品/套餐列表只读接口精确过滤：goods_sn 精确匹配返回行取 goods_name；
// 套餐编号为纯数字 shop_combo_id 时按 id 过滤取 gift_name。
// loading:false/message:false 保持后台静默：解析失败仅该格显示—，不弹全局错误
export function findShopGoodsBySn (goodsSn) {
  return request({ url: '/seller/goods/list-all', method: 'get', params: { goods_sn: goodsSn, page_no: 1, page_size: 5 }, loading: false, message: false })
}

export function findShopComboById (comboId) {
  return request({ url: 'seller/shopCombo/comboListTh', method: 'get', params: { id: comboId, page_no: 1, page_size: 5 }, loading: false, message: false })
}
